import { render, staticRenderFns } from "./ChangeManagerDialog.vue?vue&type=template&id=6b161a55&scoped=true"
import script from "./ChangeManagerDialog.vue?vue&type=script&lang=js"
export * from "./ChangeManagerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b161a55",
  null
  
)

export default component.exports